import React from 'react'
import {Route, Redirect, Link, BrowserRouter as Router} from 'react-router-dom'
import {Button, Col, Form, Input, Row} from 'antd'
import '../styles/authPage/login.css'
import logo from '../static/images/New_logo.jpg'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import LayoutLogin from '../components/LayoutLogin'
import apiRequest from '../hooks/apiRequest'
import {getDecodedTokenData} from '../hooks/DecodeJWT'
toast.configure()
class Login extends React.Component {
  constructor() {
    super()
    this.state = {
      loggedIn: false,
      api: process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/login',
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.login(values)
      }
    })
  }

  // login(data) {
  //   // const postData = {
  //   //   method: 'POST',
  //   //   headers: {'Content-Type': 'application/json'},
  //   //   body: JSON.stringify(data),
  //   // }
  //   // console.log(data)
  //   // fetch(this.state.api, postData)
  //   //   .then(res => res.json())
  //   //   .then(data => {
  //   //     console.log(data)
  //   //     debugger
  //   //     // console.log(data.detail)
  //   //     if (data.detail !== 'Wrong Password Provided') {
  //   //       if (data.data.user_role === 'CLAIMS_ACCESSOR') {
  //   //         localStorage.setItem('token', data.token)
  //   //         localStorage.setItem('loggedInUserID', data.data.id)
  //   //         localStorage.setItem('username', data.data.username)
  //   //         localStorage.setItem('userType', data.data.user_role)
  //   //         localStorage.setItem('assessorId', data.data.id)
  //   //         window.location.href = '/claims'
  //   //       }
  //   //       localStorage.setItem('token', data.token)
  //   //       localStorage.setItem('loggedInUserID', data.data.id)
  //   //       localStorage.setItem('username', data.data.username)
  //   //       localStorage.setItem('userType', data.data.user_role)
  //   //       window.location.href = '/claims'
  //   //     } else if (data.detail === 'Wrong Password Provided') {
  //   //       toast.error(
  //   //         'Invalid Email or Password',
  //   //         {position: toast.POSITION.TOP_CENTER},
  //   //         {autoClose: false},
  //   //       )
  //   //     }
  //   //   })

  //   if (data.username === 'admin' && data.password === 'admin@123') {
  //     localStorage.setItem(
  //       'token',
  //       'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE3MTAwNTc4MzEsImlkIjoxfQ.yuPgAr32c4gz7kOzdGlyJNZpjipYYXCZBstszwDPwLe_PhPEzOHl67U5e2i9LG6itTTqkBfLnMZ-tpViQYZ1Kw'
  //     );
  //     localStorage.setItem('roles', JSON.stringify({ name: 'Admin', level: 1 }));
  //     localStorage.setItem('loggedInUserID', 1);
  //     localStorage.setItem('username', 'Admin User');
  //     localStorage.setItem('userType', 'CLAIMS_PROCESSOR');
  //     window.location.href = '/claims';
  //   } else {
  //     toast.error('Invalid Email or Password', {
  //       position: toast.POSITION.TOP_CENTER,
  //       autoClose: 3000,
  //     });
  //   }
  // }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      try {
        const UserData = getDecodedTokenData(token);

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(UserData));
        localStorage.setItem('roles', JSON.stringify(UserData?.RoleName));
        localStorage.setItem('loggedInUserID', UserData?.UserId);
        localStorage.setItem(
          'username',
          `${UserData?.FirstName} ${UserData?.LastName}`
        );
        localStorage.setItem('insurerId', UserData?.UserId);

        // You can also handle role-specific setup here if needed
        // e.g. set ModalTitle as in your earlier code

        // Redirect to home/dashboard
        window.location.href = '/claims';
      } catch (err) {
        console.error('Invalid token', err);
        // Optionally redirect to login or show error
        window.location.href = '/login';
      }
    }
  }

  async login(data) {
    const response = await apiRequest(this.state.api, 'POST', data)
    const UserData = getDecodedTokenData(response?.data?.token)
    if (response.success) {
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
      this.setState({loggedIn: true})
      localStorage.setItem('token', response?.data?.token)
      localStorage.setItem('user', JSON.stringify(UserData))
      localStorage.setItem('roles', JSON.stringify(UserData?.RoleName))
      localStorage.setItem('loggedInUserID', UserData?.UserId)
      localStorage.setItem('userType', 'CLAIMS_PROCESSOR')
      localStorage.setItem(
        'username',
        `${UserData?.FirstName} ${UserData?.LastName}`,
      )
      localStorage.setItem('insurerId', response?.data?.insurerId?.id)
      switch (UserData?.RoleName) {
        case 'CLAIM_INITIATOR':
          localStorage.setItem('ModalTitle', 'Assessor')
          break
        case 'CLAIMS_ASSESSOR':
          localStorage.setItem('ModalTitle', 'Processor')
          break
        case 'CLAIM_PROCESSOR':
          localStorage.setItem('ModalTitle', 'Manager')
          break
        case 'CLAIM_MANAGER':
          localStorage.setItem('ModalTitle', 'Finance Clerk')
          break
        case 'FINANCE_CLERK':
          localStorage.setItem('ModalTitle', 'Finance Manager')
          break
        default:
          localStorage.setItem('ModalTitle', 'Assessor')
          break
      }

      window.location.href = '/claims'
    } else {
      toast.error(response.error, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form
    return (
      <div className="body-height">
        <div className="wrap-img">
          <img src={logo} style={{width: '400px', height: '150px'}} />
        </div>
        <div
          className="bg-white"
          style={{
            boxShadow: '0 0 16px grey',
            marginTop: '10px',
            borderRadius: '10px',
          }}>
          <Row>
            <Col md={12} sm={12} xs={24}>
              <div className="text-center  ">
                {/* <LayoutLogin /> */}
                <h2 className="h2-login">Sign in</h2>
                {/* <Form
                onSubmit={this.handleSubmit}
                className="form-circle-input flex justify-center">
                <input type="" />
                <input type="" />
                <input type="" />
              </Form> */}
                {/* <p className="para-text">Enter your ID number</p> */}
                {/* <Form onSubmit={this.handleSubmit} className="form-group">
                  <Form.Item>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your E-mail!',
                        },
                      ],
                    })(<input placeholder="Email" className="input-box" />)}
                  </Form.Item>

                  <Form.Item>
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Password!',
                        },
                      ],
                    })(<input placeholder="Password" className="input-box" />)}
                  </Form.Item>
                </Form>

                <Button
                  className="btn-bg-primary"
                  htmlType="submit"
                  size="large">
                  SIGN IN
                </Button> */}
                <Form onSubmit={this.handleSubmit} className="form-group-login">
                  <Form.Item>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your email',
                        },
                      ],
                    })(<Input placeholder="E-mail" className="input-box" />)}
                  </Form.Item>
                  <Form.Item className="input-box">
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Password!',
                        },
                      ],
                    })(<Input.Password placeholder="Password" />)}
                  </Form.Item>
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      size="large"
                      className="btn-bg-primary">
                      LOG-IN
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
            <Col md={12} sm={12} xs={24}>
              <div className="login-aside  flex items-center justify-center container ">
                <div className=" text-center">
                  <h2 className="heading-aside-h2 ">Good Afternoon!</h2>
                  <h6 className="h6-login text-center">
                    Please sign-in to your account to get started
                  </h6>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

const WrappedNormalLoginForm = Form.create({name: 'normal_login'})(Login)

export default WrappedNormalLoginForm
